import React, { useEffect, useState } from "react";
import DropBtn from "../modules/DropBtn";
import Button from "../modules/Button";
import "./register.scss";
import sad from "../../Assets/svg/sad.svg";
import happy from "../../Assets/svg/happy.svg";
import RadioButtons from "../modules/RadioBtn";
import tooltip from "../../Assets/svg/tooltip-icon.png";
import { LightTooltip } from "../modules/ToolTip";
import { GetBaseUrl } from "../modules/getBaseUrl";
import Status from "../modules/Status";
import { useDispatch, useSelector } from 'react-redux';
import { addCandidateInfo, addCandidatePage } from './redux/actions';


function Income() {
  const [value, setValue] = useState({ income: "", family: "" });
  const [type, setType] = useState("regular");
  const [count, setCount] = useState(0);
  const dispatch= useDispatch()
  const registeredData = useSelector(state=> state.register.registeredData)
  
  const toolTipData = () => {
    return (
      <div className="tool-tip-div">
        <div className="tool-tip-title">
          {" "}
          Family members include parents, spouses, children, siblings and
          grandparents. The relationships are created via blood, adoption, and
          marriage.
        </div>
        {/* <div className="ul-div">
          Upload one of the following:
          <ul>
            <li>No-Income Certificate</li>
            <li>Orphan Certificate</li>
          </ul>
        </div> */}
      </div>
    );
  };
  const sadText = () => {
    return (
      <div className="sad-texts">
        <div className="sad-text">
          <img className="tooltip-icon" src={tooltip} alt="tooltip" />
          Only economically disadvantaged families with annual income lesser
          than 6 lacs are eligible
        </div>
        <div className="sad-text">
          <img className="tooltip-icon" src={tooltip} alt="tooltip" />
          To stop unfair advantage, we do not accept students with immediate
          family members working with us
        </div>
      </div>
    );
  };
  const nextPage = () => {
    if (type === "regular") {
      if (registeredData.info.family === false && registeredData.info.income === false) {
        setType("happy");
      } else {
        setType("sad");
      }
    } else if (type === "happy") {
      let url = GetBaseUrl(window.location.href);
      window.location.replace(url + "/signup/nationality");      

      // let url = GetBaseUrl(window.location.href);
      // window.location.replace(url + "/signup/nationality");
    } else {
      let url = GetBaseUrl(window.location.href);
      window.location.replace(url);
    }
  };
const dispatchData =(type, e)=>{
  dispatch(addCandidateInfo([type,e]))
}
  useEffect(() => {
    let newCount = 0;
    for (let i in Object.keys(value)) {
      if (registeredData.info[Object.keys(value)[i]] !== "") {
        newCount += 1;
      }
    }
    console.log('newCount', newCount,registeredData.info, value)
    newCount = Math.abs((newCount / 2) * 100);
    setCount(newCount);
  }, [registeredData]);
  console.log('registered data',registeredData)

  return (
    <div className={`cred-section  ${type !== 'regular' ? type: 'income-page'}`}>
      {type === "sad" ? (
        <img className="sad" src={sad} alt="sad" />
      ) : type === "happy" ? (
        <img className="sad" src={happy} alt="happy" />
      ) : (
        ""
      )}
      <span className="title">
        {type === "sad"
          ? "Sorry! You are not eligible."
          : type === "happy"
          ? "Another ‘yes’!"
          : "Family & Income details"}
      </span>
      <span className="sub-title">
        {type === "sad"
          ? sadText()
          : type === "happy"
          ? "Your family and income details qualify."
          : "Check whether your family and other details qualify"}
      </span>
      {type === "regular" && <Status count={count} />}
      {type === "regular" && (
        <div className="cred-fields">
          <div className="radio-item">
            <span className="radio-title">
              What is the total yearly income of your family
            </span>
            <div className="radio-options">
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={() => dispatchData('income',true)}
                  value={registeredData.info.income? 'yes':'no'}
                  option={'yes'}
                />
                6 lacs or more
              </div>
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={() =>dispatchData('income',false)}
                  value={registeredData.info.income==="" ? '':registeredData.info.income ? 'yes':'no'}
                  option={'no'}
                />{" "}
                Less than 6 lacs
              </div>
            </div>
          </div>
          <div className="radio-item">
            <span className="radio-title">
              Does anyone from your family work with IDFC FIRST Bank?
              <LightTooltip title={toolTipData()}>
                <img src={tooltip} alt="tooltip" />
              </LightTooltip>
            </span>
            <div className="radio-options">
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={() => dispatchData('family',true)}
                  value={registeredData.info.family==="" ? '':(registeredData.info.family && registeredData.info.family!=="") ? 'yes':'no'}
                  option={"yes"}
                />
                Yes
              </div>
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={() =>dispatchData('family',false)}
                  value={registeredData.info.family==="" ? '':(registeredData.info.family && registeredData.info.family!=="") ? 'yes':'no'}
                  option={"no"}
                />
                No
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="cred-btn">
        <Button
          disabled={registeredData.info.family===""  || registeredData.info.income==="" }
          onClickHandler={() => nextPage()}
          value={type === "sad" ? "Back to Home" : "Next"}
          type={"contained"}
        />
      </div>
    </div>
  );
}

export default Income;
